import React, {FC} from 'react';
import classes from './HLErrorMessage.module.scss'

interface HLErrorMessageProps {
  error?: string | null;
}

const HLErrorMessage: FC<HLErrorMessageProps> = ({error}) => {
  return error ? <p className={classes.errorMessage}>{error}</p> : <></>;
};

export default HLErrorMessage;